import { render, staticRenderFns } from "./RecentUpdates.vue?vue&type=template&id=4a05cd66&scoped=true"
import script from "./RecentUpdates.vue?vue&type=script&lang=js"
export * from "./RecentUpdates.vue?vue&type=script&lang=js"
import style0 from "./RecentUpdates.vue?vue&type=style&index=0&id=4a05cd66&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a05cd66",
  null
  
)

export default component.exports